import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { _get } from "../services/apiClient";
import MenuItem from "./MenuItem";

// Today's specials as one swipeable row of orderable cards at the top of the
// home page. Takes no space when nothing is marked as today's special.
function ChefPicks({ dineInParams, cart, setCart, handleClick }) {
  const { t } = useTranslation();
  const [products, setProducts] = useState([]);
  const { mode, tableId, restaurantId } = dineInParams || {};

  useEffect(() => {
    let cancelled = false;
    const params = new URLSearchParams({ category: "todays_special", page: 1, limit: 10 });
    if (mode) {
      params.set("mode", mode);
      params.set("tableId", tableId);
      params.set("restaurantId", restaurantId);
    }
    _get(`/products/menu?${params.toString()}`)
      .then((res) => {
        if (!cancelled) setProducts(res.data.products || []);
      })
      .catch((err) => console.error("Error fetching today's specials:", err));
    return () => {
      cancelled = true;
    };
  }, [mode, tableId, restaurantId]);

  if (!products.length) return null;

  return (
    <section className="w-full pt-8 pb-4 sm:pt-12">
      <h2 className="px-5 sm:px-8 md:px-12 lg:px-16 xl:px-20 mb-4 text-2xl sm:text-3xl font-heading font-extrabold text-brand-900">
        <span className="me-2">⭐</span>
        {t("todaysSpecial")}
      </h2>
      <div className="flex gap-3 overflow-x-auto snap-x snap-mandatory scroll-px-5 px-5 sm:px-8 md:px-12 lg:px-16 xl:px-20 pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {products.map((product) => (
          <div key={product._id} className="snap-start flex-shrink-0 w-[85%] max-w-[320px]">
            <MenuItem
              MenuItem={product}
              handleClick={handleClick}
              products={products}
              cart={cart}
              setCart={setCart}
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default ChefPicks;
